import HeadingArea from '../../general/HeadingArea';
import React, { useState, useEffect } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { FaCheck, FaFileImage, FaFilePdf } from 'react-icons/fa';
import axios from 'axios'
import { RiDeleteBin6Line } from 'react-icons/ri';

const Remark = ({ setLoading, userData }) => {
  
    const [availableSections, setAvailableSections] = useState([]);
    const [selectedClassId, setSelectedClassId] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [classes, setClasses] = useState([]);
    const [academicYears, setAcademicYears] = useState([]);
    const [selectedAY, setSelectedAY] = useState('');
    const [std, setStd] = useState([]);
 
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [selectedMem, setSelectedMem] = useState('');
    const [showIssue, setShowIssue] = useState(false);
const [selectedRemark, setSelectedRemark] = useState('');
  
    const [remarkDate, setRemarkDate] = useState('');
    const [remarkDescription, setRemarkDescription] = useState('');
    const [attachment, setAttachment] = useState(null);
    const [remark, setRemark] = useState([]);
      const [searchTerm, setSearchTerm] = useState('');
const [showDelete, setShowDelete] = useState(false);

   
    const fetchClasses = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-classes');
            if (response.ok) {
                const data = await response.json();
                setClasses(data);
            } else {
                console.error('Failed to fetch class');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAcademicYears = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-academic-years');
            if (response.ok) {
                const data = await response.json();
                setAcademicYears(data);
            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Initial fetches for classes and academic years
    useEffect(() => {
        fetchClasses();
        fetchAcademicYears();
    }, []);



    useEffect(() => {
        if (selectedClassId) {
            const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
            if (selectedClass && selectedClass.sections) {
                const sectionArray = selectedClass.sections
                    .split(',')
                    .map((s) => s.trim())
                    .filter((s) => s !== '');
                setAvailableSections(sectionArray);
            } else {
                setAvailableSections([]);
            }
            setSelectedSection('');
        } else {
            setAvailableSections([]);
            setSelectedSection('');
        }
    }, [selectedClassId, classes]);




    const handleSearch = async (e) => {
        e.preventDefault();

        if (!selectedAY || !selectedClassId) {
            alert('Please select both Academic Year and Class to search.');
            return;
        }

        setLoading(true);

        try {
            // Get class_name from classId
            const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
            const className = selectedClass ? selectedClass.class_name : '';

            // Build query params
            const params = new URLSearchParams();
            params.append('ay', selectedAY);
            params.append('class_name', className);

            if (selectedSection) {
                params.append('section', selectedSection);
            }

            const url = `https://api.kcian.in/get-student?${params.toString()}`;

            const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
                setStd(data);
            } else {
                console.error('Failed to fetch students');
            }
        } catch (error) {
            console.error('Error fetching students:', error);
        } finally {
            setLoading(false);
        }
    };
   

    const handleShowIssue = (mem) => {
        setShowIssue(true);
        setSelectedMem(mem);
        fetchRemark(mem.reg_no);
    }
 
    const handleSubmit = async (e) => {
        e.preventDefault(); 

        setLoading(true);

        try {
            // Create FormData object
            const formData = new FormData();
            formData.append('reg_no', selectedMem.reg_no);
            formData.append('year', selectedAY);
            formData.append('added_by', userData.user_id);
            formData.append('rem_date', remarkDate);
            formData.append('description', remarkDescription);

            if (attachment) {
                formData.append('file', attachment);
            }

           
            const response = await axios.post('https://api.kcian.in/add-remark', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            setResponse2({ message: 'Remark Added Successfully.', status: 'success' });
            setRemarkDate('');
            setRemarkDescription('');
            setAttachment(null);

            fetchRemark();
            setTimeout(() => {
                setResponse2('');
            }, 2000);
            setShowIssue(false)

        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
                    setLoading(false);
        setTimeout(() => {
          setResponse2('');
        }, 3000);   

        }
    };

    const fetchRemark = async (reg_no) => {
        setLoading(true);
        try {
            const res = await axios.get(`https://api.kcian.in/fetch-remark/${reg_no}`);
            console.log(res.data);
            setRemark(res.data);
        } catch (error) {
            console.log(error)
        } finally {
                    setLoading(false);
        }
    };

  
  
  const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}-${month}-${year} `;
};


const filterDetail = std.filter(r => {
  const term = searchTerm.toLowerCase();
  return (
    r.name.toLowerCase().includes(term) ||
        r.class_name.toLowerCase().includes(term) ||
         r.section.toLowerCase().includes(term)||
          r.mobile.toLowerCase().includes(term)||
           r.reg_no.toLowerCase().includes(term) 
           
  );
});



    const handleShowDelete = (data) => {
    setSelectedRemark(data);
    setShowDelete(true);
  }


                const handleDelete = async (cId, cMedia) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-remark/${cId}?media=${encodeURIComponent(cMedia)}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setRemark((prevData) => prevData.filter((product) => product.id !== cId));
        setShowDelete(false);
        setResponse2({ message: 'Remark Deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting content:', error);
    }
  };



    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='Student' message2='Remark' />

                                                    {/* {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />} */}


                    <form onSubmit={handleSearch} className='profile-card'>
                        <span className="profile-heading">Select Criteria</span> 
                          

                        <div className='d-md-flex d-sm-flex d-block mt-3'>
                            <div className="mb-4 w-100 me-3">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select AY*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedAY}
                                        onChange={(e) => setSelectedAY(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Academic Year --</option>
                                        {academicYears.map((ay) => (
                                            <option key={ay.year} value={ay.year}>
                                                {ay.year} --- {ay.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="mb-4 w-100 me-3">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select Class*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedClassId}
                                        onChange={(e) => setSelectedClassId(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Class --</option>
                                        {classes.map((cls) => (
                                            <option key={cls.id} value={cls.id}>
                                                {cls.class_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="mb-4 w-100">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select Section*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedSection}
                                        onChange={(e) => setSelectedSection(e.target.value)}
                                        disabled={availableSections.length === 0}
                                    >
                                        <option value="">-- Select Section --</option>
                                        {availableSections.map((section, idx) => (
                                            <option key={idx} value={section}>
                                                {section}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className='text-end'>
                            <button type='submit' className='profile-btn2'>
                                <AiOutlineSearch /> Search
                            </button>
                        </div>
                    </form>


                    <div className='profile-card mt-4'>
                        <span className="profile-heading">Student List</span>
                        {/* Render student list here */}
                        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                         <div className='profile-input-area ms-auto col-lg-3 border-0 '>
                                        <input
                                            type='text'
                                            name='search'
                                            className='profile-input border-bottom rounded-0'
                                            placeholder='Search...'
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>

                        <div className='table-responsive mt-3'>
                            <table className='w-100 text-center '>

                                <thead className='account-thead'>
                                    <th className='rounded-start-4'>S No</th>
                                    <th>Reg No</th>
                                    <th>Name</th>
                                    <th>Class(Section)</th>
                                    <th>Mobile No</th>
                                    <th className='rounded-end-4'>Activity</th>
                                </thead>


                                {filterDetail.length === 0 ? (
                                    <tr className='text-center account-tr'><td colSpan={8}>No Student Data found</td></tr>
                                ) : (
                                    <>
                                        {filterDetail.map((student, idx) => (
                                            <tr className='account-tr' key={student.id}>
                                                <td>{idx + 1}</td>
                                                <td>{student.reg_no}</td>
                                                <td>{student.name}</td>
                                                <td>{student.class_name}({student.section})</td>
                                                <td>{student.mobile}</td>

                                                <td className='py-3 cursor-pointer'><span className='profile-btn2' onClick={() => handleShowIssue(student)}>Remark</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                )}

                            </table>
                        </div>
                        {/* table ends */}

                    </div>

                </div>
            </section>


            {showIssue && selectedMem && (
                <>
                    <section className='ins-dialog'>
                        <div className='col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

                            <button className='profile-btn2' onClick={() => setShowIssue(false)}>Go Back</button>

                            {/* {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />} */}


                            <div className='row mt-2'>

                                <div className='col-lg-4 col-md-5 col-12 my-2'>


                                    {/* left top ends */}

                                    <div className='profile-card'>
                                    <p className='profile-heading mb-4'>Add Remark</p>

                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Student Name*</label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="profile-input"
                                                value={selectedMem.name}
                                                required
                                                readOnly
                                            />

                                        </div>

                                        <div className='profile-input-area mb-4'>
                                            <label className='profile-badge'>Remark Date*</label>
                                            <input
                                                type="date"
                                                className="profile-input"
                                                value={remarkDate}
                                                onChange={(e) => setRemarkDate(e.target.value)}
                                                required
                                            />
                                        </div>



                                        {/* Note */}
                                        <div className="profile-input-area mt-1 mb-4">
                                            <label htmlFor="note" className="profile-badge">
                                                Remark Description*
                                            </label>
                                            <textarea
                                                id="note"
                                                name="note"
                                                className="profile-input"
                                                value={remarkDescription}
                                                onChange={(e) => setRemarkDescription(e.target.value)}
                                                required
                                            />

                                        </div>

                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Attachment</label>
                                            <input
                                                type="file"
                                                name="file"
                                                className="profile-input"
                                                accept="image/*,application/pdf"

                onChange={(e) => {
      const file = e.target.files[0];

      if (file) {
        const maxSizeInMB = 2;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

        if (file.size > maxSizeInBytes) {
         setResponse2({ message: 'File size should not exceed 2MB.', status: 'danger' });
          e.target.value = ''; // clear the selected file
          setAttachment(null);
           setTimeout(() => {
                setResponse2('');
            }, 2000);
        } else {
          setAttachment(file); // valid file
        }
      }
    }}
    />

                                        </div>


                                        <div className='col-12 text-center'>
                                            <button
                                                className="profile-btn"
                                                onClick={handleSubmit}
                                            >
                                                <FaCheck /> Save
                                            </button></div>

                                    </div>
                                   
                                </div>
                                {/* left ends */}



                                <div className='col-lg-8 col-md-7 col-12 my-2'>
                                    <div className='profile-card'>
                                    <p className='emp-name2'> Remark List</p>
                            {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


                                        <div className="table-responsive">
                                            <table className="table w-100">
                                                <thead className="account-thead rounded-4">

                                                    <th className='rounded-start-4'>S No</th>
                                                    <th>Added By</th>
                                                    <th>AY</th>
                                                    <th>Remark Date</th>
                                                    <th>Description</th>
                                                    <th>Attachment</th>
                                                    <th className='rounded-end-4'>Activity</th>
                                                </thead>
                                                <tbody>
                                                    {remark.length > 0 ? (
                                                        remark.map((data, id) => (
                                                            <tr className='account-tr' key={id}>
                                                                <td>{id + 1}</td>
                                                                <td> {data.addedby_name} ({data.designation})</td>
                                                                <td>{data.year}</td>
                                                                    <td>{formatDate(data.rem_date)}</td>
                                                                <td>{data.description}</td>
                                            <td>
                                                {data.file ? (() => {
                                                    // Extract file extension
                                                    const ext = data.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${data.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td>                                                                
<td><RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(data)} /></td>
                                                            </tr>
                                                        ))) :
                                                        <tr className='account-tr text-center'>
                                                            <td colSpan="7">
                                                                No Data found.
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>

                                            </table>
                                        </div>



                                    </div>
                                </div>



                            </div>
                            {/* row ends */}

                        </div>
                    </section>

                </>
            )}



                  {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Remark!</p>

<div className='table-responsive'>
<table className='w-100'>

                                    <thead className='account-thead'>
                                        <th className='rounded-start-4'>Added By</th>
                                                    <th>AY</th>
                                                    <th>Remark Date</th>
                                                    <th>Description</th>
                                        <th className='rounded-end-4'>Attachment</th>
                                    </thead>

<tr className='account-tr'>
                                                                <td> {selectedRemark.addedby_name} ({selectedRemark.designation})</td>
                                                                <td>{selectedRemark.year}</td>
                                                                    <td>{formatDate(selectedRemark.rem_date)}</td>
                                                                <td>{selectedRemark.description}</td>
                                            <td>
                                                {selectedRemark.file ? (() => {
                                                    // Extract file extension
                                                    const ext = selectedRemark.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedRemark.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td>         
</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Remark will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedRemark.id, selectedRemark.file)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}
        </>
    )
}

export default Remark